import { useEffect, useRef } from "react";

export const WidgetEmbed = ({ code, bare = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !code) return;
    el.innerHTML = code;
    el.querySelectorAll("script").forEach((old) => {
      const s = document.createElement("script");
      [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
    return () => { el.innerHTML = ""; };
  }, [code]);
  return (
    <div ref={ref}
      className={bare ? "" : "mt-10 border border-white/10 p-4 sm:p-8 bg-[#121214]"}
      data-testid={bare ? "booking-widget-embed-artist" : "booking-widget-embed"} />
  );
};
